import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFamily = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("style", { children: ".a{fill:#24a81b;}.a,.c{stroke:#24a81b;}.b{clip-path:url(#a);}.c,.d{fill:none;}.c{stroke-linecap:round;stroke-linejoin:round;stroke-width:3.125px;}" }), /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("rect", {
			className: "a",
			width: 50,
			height: 50,
			transform: "translate(14110 251)"
		})
	})] }), /* @__PURE__ */ _jsx("g", {
		className: "b",
		transform: "translate(-14110 -251)",
		children: /* @__PURE__ */ _jsxs("g", {
			transform: "translate(14110 251)",
			children: [/* @__PURE__ */ _jsxs("g", {
				transform: "translate(-8)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						className: "c",
						d: "M12.118,15.243a2.253,2.253,0,1,0,3.187,0,2.253,2.253,0,0,0-3.187,0",
						transform: "translate(33.542 7.719)"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "c",
						d: "M37.016,14.025a5.208,5.208,0,1,1-7.366,0,5.208,5.208,0,0,1,7.366,0",
						transform: "translate(-0.292 -0.5)"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "c",
						d: "M42.708,37.5V35.417a6.25,6.25,0,0,0-6.25-6.25h-6.25a6.25,6.25,0,0,0-6.25,6.25V37.5",
						transform: "translate(-0.292 -0.5)"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "c",
						d: "M7.292,30.574h3.186c2.639,0,3.641,1.063,3.641,3.7v1.593",
						transform: "translate(37.978 -0.036)"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "c",
						d: "M15.305,15.243a2.253,2.253,0,1,1-3.187,0,2.253,2.253,0,0,1,3.187,0",
						transform: "translate(5.131 7.719)"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "c",
						d: "M14.118,30.574H10.932c-2.639,0-3.641,1.063-3.641,3.7v1.593",
						transform: "translate(6.709 -0.036)"
					})
				]
			}), /* @__PURE__ */ _jsx("path", {
				className: "d",
				d: "M0,0H50V50H0Z"
			})]
		})
	})]
});
export default SvgFamily;
